<template>
  <div>
    <div class="container-fluid overflow-auto">
      <div class="col-12 pt-3 pb-3 pl-4 d-flex flex-wrap">
        <div class="col-12 col-md-6">
          <h3><i class="fa fa-user-circle"></i> Provedores</h3>
        </div>
        <div class="col-12 col-md-6 text-md-right mt-3 mt-md-0">
          <div class="col-12 col-md-3 ml-auto">
            <defaultbutton
              class="defaultbutton"
              :onClick="() => onShowSearch()"
              btnVariant="btn-third"
              icon="fas fa-search"
              text="Pesquisar"
            />
            <defaultbutton v-if="list == 0" class="defaultbutton" :onClick="() => openModalAdd()" btnVariant="btn-third" icon="fas fa-plus" text="Adicionar"/>
          </div>
        </div>
      </div>
      <ProvedorList @clicked-open="openModalInfo" :list="list" @clicked-add="openModalAdd" />
    </div>
    <ProvedorInformation class="pos" @clicked-close="closeModalInfo" v-show="showInfo" :infoProvider="infoProvider" @carregar="onLoad" />
    <ProvedorAdd class="pos" v-show="showAdd" @clicked-close="closeModalAdd" @carregar="onLoad" />
    <SidebarSearch @filter="searchList" />
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import ProvedorList from './list/ProvedorList.vue'
import ProvedorFilter from './filter/ProvedorFilter.vue'
import ProvedorInformation from './information/ProvedorInformation.vue'
import ProvedorAdd from './add/ProvedorAdd.vue'
import NumRepository from '@/shared/http/repositories/access/cadastroNum.js'
import SidebarSearch from '@/views/private/configurations/parametros_atendimento/provedores/filter/SidebarProvedor.vue'
import defaultbutton from '@/components/UI/button/defaultButton.vue'

export default {
  name: 'Provider',
  data () {
    return {
      list: [],
      showAdd: false,
      showInfo: false,
      infoProvider: null
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  created () {
    this.onLoad()
  },
  components: {
    ProvedorList,
    ProvedorFilter,
    ProvedorAdd,
    ProvedorInformation,
    SidebarSearch,
    defaultbutton
  },
  methods: {
    onNew () {
      this.showAdd = true
    },
    searchList (list) {
      this.list = list
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ModeloAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    },
    openModalAdd () {
      this.showAdd = true
    },
    openModalInfo (card) {
      this.infoProvider = card
      this.showInfo = true
    },
    closeModalInfo () {
      this.showInfo = false
    },
    closeModalAdd () {
      this.showAdd = false
    },
    onLoad () {
      NumRepository.getEnvAll()
        .then((res) => {
          this.list = res.data.content
        })
      this.showAdd = false
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>

<style lang="scss" scoped>
.pos {
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/provedores/Provedor.vue